export default __webpack_public_path__ + "alberta-person.1b3df9560e3a46b3d953.svg";